export default __webpack_public_path__ + "static/media/icon-players.bac67c01.svg";